import { Signage, signageRebootSystem, signageReload } from '../../../Signage';
import { displayCameras } from '../../../Platform/Reach/ExacqVision';
import { GlobalSignagePlatform } from './Platform';
import { isAtLeastVersion } from '../../../Signage/utility';
import {
    GlobalDisplay,
    LegacyGlobalSignageInterface,
    GlobalZone,
    GlobalMessagingClient,
} from './Interface/Signage';
import type { Display } from '../../../Display';
import {
    getDisplayById,
    getZoneById,
    pauseCurrentDisplay,
    playCurrentDisplay,
    stopCurrentDisplay,
} from '../../../Display';
import { pushReceiver } from '../../../MessagingClient/instance';

export const GlobalSignage: LegacyGlobalSignageInterface = {
    get messagingClient(): GlobalMessagingClient | undefined {
        return pushReceiver();
    },

    get playerUuid(): string | null {
        return Signage.playerUuid;
    },

    platform: GlobalSignagePlatform,

    ExacqVision: { displayCameras },

    getDisplayById(id: number): GlobalDisplay | null {
        let display: Display | null = null;
        try {
            display = getDisplayById(id);
        } catch (err) {
            if (err instanceof ReferenceError) {
                // do nothing, this is expected when a display cannot be found
            } else {
                throw err;
            }
        }

        if (display === null) {
            return null;
        }

        return createGlobalDisplay(display);
    },

    getZoneById(id: number): GlobalZone | null {
        let zone = null;
        try {
            zone = getZoneById(id);
        } catch (err) {
            if (err instanceof ReferenceError) {
                // do nothing, this is expected when a zone cannot be found
            } else {
                throw err;
            }
        }
        return zone;
    },

    RebootSystem(): Promise<void> {
        return signageRebootSystem();
    },

    Reload(): void {
        return void signageReload();
    },

    /**
     * @see {@link isAtLeastVersion}
     */
    isAtLeastVersion(minVersion: string): boolean {
        return isAtLeastVersion(minVersion);
    },

    async playCurrentDisplay(): Promise<void> {
        await playCurrentDisplay();
    },

    async pauseCurrentDisplay(): Promise<void> {
        await pauseCurrentDisplay();
    },

    async stopCurrentDisplay(): Promise<void> {
        await stopCurrentDisplay();
    },
};

function createGlobalDisplay(display: Display): GlobalDisplay {
    return {
        name: 'Display',
        pauseAllZones: (exclusions?: number[]) => display.pauseAllZones(exclusions),
        stopAllZones: (exclusions?: number[]) => display.stopAllZones(exclusions),
        playAllZones: (exclusions?: number[], cancelFade?: boolean) =>
            display.playAllZones(exclusions, cancelFade),
        get wrapperElement() {
            return display.wrapperElement;
        },
    };
}
